<template>
    <div style="border: 1px solid #E0E0E0; overflow: scroll; height: 330px; width:100%; color:black;">
        <table style="width:100%">
            <tr style="height:50px;">
                <td style="width:10px; background:#5DC0FF;"></td>
                <td>
                    <div style="text-align: left; font-size: 16px; font-weight: bold; color:black;">设备事件</div>
                </td>
            </tr>
        </table>
        <el-row style="height:30px; padding:10px;">
            <el-col v-for="event in list" :key="event">
                <b>{{event.description}}</b>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import XLSX from 'xlsx'

export default {
    components:{
        
    },
    data(){
        return{
            list: []
        }
    },
    computed:{
        belt(){
            return this.$store.ningboStore.getters.getWorkorder.belt;
        },
        berth(){
            return this.getBerth(this.$store.ningboStore.getters.getWorkorder.berthId);
        },
        area(){
            return this.getArea(this.$store.ningboStore.getters.getWorkorder.areaId);
        },
        type(){
            return this.getType(this.$store.ningboStore.getters.getWorkorder.typeId, this.$store.ningboStore.getters.getWorkorder.number);
        },
        number(){
            return this.$store.ningboStore.getters.getWorkorder.number + 'T'
        },
        beginTime(){
            return new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).format('yyyy-MM-dd hh:mm:ss');
        },
        duration(){
            return this.formatDuration(new Date(this.$store.ningboStore.getters.getWorkorder.endTime).getTime() - new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).getTime());
        },
        energy(){
            return this.$store.ningboStore.getters.getWorkorder.energy + 'KWH'
        },
        berthList(){
            return this.$store.ningboStore.getters.getBerthList;
        },
        devicesSummary(){
            var list = [];
            var de = JSON.parse(this.$store.ningboStore.getters.getWorkorder.devsEnergy);
            for(var key in de){
                list.push({
                    dev: key,
                    energy: de[key]
                })
            }
            return list
        },
        areaList(){
            return this.$store.ningboStore.getters.getAreaList;
        },
        typeList(){
            return this.$store.ningboStore.getters.getTypeList;
        }
    },
    mounted(){
        var bd = new Date(this.$store.ningboStore.getters.getWorkorder.beginTime).format('yyyy-MM-dd hh:mm:ss');
        var ed = new Date().format('yyyy-MM-dd hh:mm:ss');
        if(this.$store.ningboStore.getters.getWorkorder.runState == 2){
            ed = new Date(this.$store.ningboStore.getters.getWorkorder.endTime).format('yyyy-MM-dd hh:mm:ss');
        }
        var beltId = this.$store.ningboStore.getters.getWorkorder.beltId
        this.$api.ningboApi.findAllDevEventsByBeltId(beltId, bd, ed, response => {
            this.list = response
        })
    },
    watch:{
    },
    methods:{
        getBerth(berthId){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == berthId){
                    return this.berthList[i].name;
                }
            }
            return berthId
        },
        getArea(areaId){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == areaId){
                    return this.areaList[i].name;
                }
            }
            return areaId
        },
        getType(typeId, number){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == typeId){
                    return this.typeList[i].name;// + ':' + number + 'T';
                }
            }
            return typeId;// + ':' + number
        },
        formatBeginTime (row, column) {
            return new Date(eval('row.' + column.property)).format('yyyy-MM-dd hh:mm:ss');
        },
        formatBert(row, column){
            for(var i=0; i<this.berthList.length; i++){
                if(this.berthList[i].id == row.berthId){
                    return this.berthList[i].name;
                }
            }
            return row.berthId
        },
        formatArea(row, column){
            for(var i=0; i<this.areaList.length; i++){
                if(this.areaList[i].id == row.areaId){
                    return this.areaList[i].name;
                }
            }
            return row.areaId
        },
        formatType(row, column){
            for(var i=0; i<this.typeList.length; i++){
                if(this.typeList[i].id == row.typeId){
                    return this.typeList[i].name + ':' + row.number + 't';
                }
            }
            return row.typeId + ':' + row.number
        },
        formatState(row, column){
            if(row.runState == 0){
                return '运行中'
            }else if(row.runState == 1){
                return '暂停'
            }else if(row.runState == 2){
                return '结束'
            }else{
                return 'N/A'
            }
        },
        formatDuration(duration){
            duration /= 1000;
            var day = parseInt(duration / (60 * 60 * 24));
            duration -= day * (60 * 60 * 24);
            var hour = parseInt(duration / (60 * 60));
            duration -= hour * (60 * 60);
            var minute = parseInt(duration / 60);
            var second = duration - minute * 60;

            var str = '';
            if(day > 0){
                str = day + '天'
            }
            str += hour + '小时' + minute + '分' + second + '秒'
            return str;
        },
    }
}
</script>